/*
 * Forge Maestro
 * (c) Honeywell
 */

import { jsxs, jsx } from 'react/jsx-runtime';
import { forwardRef } from 'react';
import styles from './IconBase.module.scss.js';

let nextUniqueId = 0;
const IconBase = forwardRef((props, ref) => {
    const { children, className = '', name, title, stroke = 'currentColor', fill = 'none', height = '100%', width = '100%', viewBox = '0 0 24 24', } = props;
    const titleId = title ? `${name}-${nextUniqueId++}` : undefined;
    return (jsxs("svg", Object.assign({ ref: ref, xmlns: "http://www.w3.org/2000/svg", fill: fill, stroke: stroke, viewBox: viewBox, height: height, width: width, preserveAspectRatio: "xMidYMid meet", focusable: "false", role: "img", "aria-hidden": !titleId, "aria-labelledby": titleId, className: `${styles.icon} ${className}` }, { children: [titleId ? jsx("title", Object.assign({ id: titleId }, { children: title })) : undefined, children] })));
});

export { IconBase };
//# sourceMappingURL=IconBase.js.map
